module.exports = __webpack_public_path__ + "aa4fdacf8d7f89275bffa09ebeb0eaf7.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-flag-kit/assets/TC.svg
// module id = 7LuT
// module chunks = 0